export const PRO = "PRO";
export const STARTER = "STARTER";
export const LIGHT = "LIGHT";
export const LIGHT_1GB = "LIGHT_1GB";
export const UP = "UP";
export const SMART = "SMART";
export const COMPANY = "COMPANY";
export const VIP = "VIP";
export const VIP_3K = "VIP_3K";
export const VIP_5K = "VIP_5K";
export const VIP_10K = "VIP_10K";
export const VIP_20K = "VIP_20K";
export const VIP_40K = "VIP_40K";

export const PLAN_PACKAGE_NAMES = [
  { default: LIGHT_1GB, display: "Light" },
  { default: UP, display: "Up" },
  { default: SMART, display: "Smart" },
  { default: COMPANY, display: "Company" },
  { default: VIP, display: "Vip" },
  { default: VIP_3K, display: "Vip 3.000" },
  { default: VIP_5K, display: "Vip 5.000" },
  { default: VIP_10K, display: "Vip 10.000" },
  { default: VIP_20K, display: "Vip 20.000" },
  { default: VIP_40K, display: "Vip 40.000" }
];

export const PLAN_PACKAGE_DISPLAY_NAMES = {
  LIGHT_1GB: "Light",
  UP: "Up",
  SMART: "Smart",
  COMPANY: "Company",
  VIP: "Vip",
  VIP_3K: "Vip 3.000",
  VIP_5K: "Vip 5.000",
  VIP_10K: "Vip 10.000",
  VIP_20K: "Vip 20.000",
  VIP_40K: "Vip 40.000"
};

export const RESOURCE_ICONS = {
  USER: "fa-user-o",
  DISK_SPACE: "fa-paperclip",
  CREDITS: "fa-folder-o",
  CLIPPINGS: "fa-file-text-o"
};

export const RESOURCE_AVAILABILITY_ADJECTIVES = {
  USED: "utilizado[PLURAL]",
  AVAILABLE: "disponíve[PLURAL]"
};

export const RESOURCE_NAMES = {
  USER: "usuário[PLURAL]",
  DISK_SPACE: "de espaço na nuvem",
  CREDITS: "processo[PLURAL] monitorado[PLURAL]",
  CLIPPINGS: "nome[PLURAL] para captura de publicações"
};

export const resourceTypeSortingOrder = {
  USER: 2,
  DISK_SPACE: 4,
  CREDITS: 1,
  CLIPPINGS: 3
};
